import { render, staticRenderFns } from "./Proforme.vue?vue&type=template&id=1504604a&scoped=true"
import script from "./Proforme.vue?vue&type=script&lang=js"
export * from "./Proforme.vue?vue&type=script&lang=js"
import style0 from "./Proforme.vue?vue&type=style&index=0&id=1504604a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1504604a",
  null
  
)

export default component.exports